import React from 'react';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import get from 'lodash.get';

import GameStat from "@/components/GameStats/GameStat";

const useStyles = makeStyles(theme => ({
  container: {
    padding: 10,
  },
  divider: {
    margin: '20px 0',
  }
}));

function getStat(stats, path) {
  return Object.entries(stats).map(stat => ({
    id: stat[0],
    stat: get(stat[1], path)
  }));
}

function GameStats({ teams, stats }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <GameStat title="Shots on Goal" teams={teams} stats={getStat(stats, 'shots.total')} />
      <Divider className={classes.divider} />
      <GameStat title="Hits" teams={teams} stats={getStat(stats, 'hits')} />
      <Divider className={classes.divider} />
      <GameStat title="Penalty Minutes" teams={teams} stats={getStat(stats, 'pims')} />
      <Divider className={classes.divider} />
      <GameStat title="Faceoff Wins" teams={teams} stats={getStat(stats, 'faceoffWins')} />
      <Divider className={classes.divider} />
      <GameStat title="Blocked Shots" teams={teams} stats={getStat(stats, 'blockedShots')} />
    </div>
  )
}

export default GameStats;
